/* Reviews — rendered from Supabase, matching src/hooks/useReviews.ts.
   RLS only exposes status = 'approved' to anon, so the pending queue can
   never leak here even though the query has no status filter of its own.

   Cards are appended DIRECTLY into the grid (no wrapper element) so that the
   grid's default align-items: stretch makes every card in a row the same
   height — a wrapper div was stretching instead of the card, which left the
   white panels ragged. */

(function () {
  var TRUNCATE = 140;

  /* Reviews submitted without a photo fall back to the brand tile, the same
     way the original Wix reviews did. The URL is published by
     snippets/review-lightbox.liquid, which both reviews sections render. */
  var phEl = document.querySelector('[data-rv-placeholder]');
  var PLACEHOLDER = (phEl && phEl.getAttribute('data-rv-placeholder')) || '';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var STAR = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';

  function cardHtml(r) {
    var body = String(r.description || '').trim();
    var short = body.length > TRUNCATE ? body.slice(0, TRUNCATE) + '…' : body;
    var n = parseInt(r.rating, 10) || 0;
    var stars = '';
    for (var i = 0; i < n; i++) stars += STAR;

    var img = r.image_url || PLACEHOLDER;

    return '<div class="rvc" data-rv-open role="button" tabindex="0"' +
      ' data-rv-title="' + esc(r.title) + '"' +
      ' data-rv-rating="' + n + '"' +
      ' data-rv-img="' + esc(img) + '"' +
      ' data-rv-body="' + esc(body) + '">' +
      '<div class="rvc__media">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(r.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="rvc__body">' +
        '<div class="rvc__stars" aria-label="' + n + ' out of 5 stars">' + stars + '</div>' +
        '<h3 class="rvc__name">' + esc(r.title) + '</h3>' +
        '<p class="rvc__text">"' + esc(short) + '"' +
          (body.length > TRUNCATE ? '<span class="rvc__more">Read more</span>' : '') +
        '</p>' +
      '</div>' +
    '</div>';
  }

  function wireTilt(scope) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    scope.querySelectorAll('.rvc').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 6;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 6;
        card.style.transform = 'perspective(800px) rotateY(' + x + 'deg) rotateX(' + (-y) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(800px) rotateY(0deg) rotateX(0deg)';
      });
    });
  }

  function wireLightbox(scope) {
    var dlg = document.querySelector('[data-rv-dialog]');
    if (!dlg) return;
    var dImg = dlg.querySelector('[data-rv-dimg]');
    var dStars = dlg.querySelector('[data-rv-dstars]');
    var dTitle = dlg.querySelector('[data-rv-dtitle]');
    var dText = dlg.querySelector('[data-rv-dtext]');

    function open(card) {
      var img = card.getAttribute('data-rv-img');
      dImg.innerHTML = img ? '<img src="' + esc(img) + '" alt="">' : '';
      dImg.style.display = img ? '' : 'none';
      var n = parseInt(card.getAttribute('data-rv-rating'), 10) || 0;
      dStars.innerHTML = '';
      for (var i = 0; i < n; i++) dStars.insertAdjacentHTML('beforeend', STAR);
      dTitle.textContent = card.getAttribute('data-rv-title');
      dText.textContent = '"' + card.getAttribute('data-rv-body') + '"';
      dlg.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() { dlg.classList.remove('is-open'); document.body.style.overflow = ''; }

    scope.querySelectorAll('[data-rv-open]').forEach(function (card) {
      card.addEventListener('click', function () { open(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(card); }
      });
    });
    if (!dlg.dataset.wired) {
      dlg.dataset.wired = '1';
      dlg.querySelectorAll('[data-rv-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dlg.classList.contains('is-open')) close();
      });
    }
  }

  async function mount(root) {
    var grid = root.querySelector('[data-rv-grid]');
    if (!grid) return;

    var featured = root.getAttribute('data-featured') === 'true';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 0;   /* 0 = all */
    var page = parseInt(root.getAttribute('data-page'), 10) || 0;     /* 0 = no paging */
    var moreWrap = root.querySelector('[data-rv-more]');
    var empty = root.querySelector('[data-rv-empty]');

    var sb = await window.sbReady;
    var q = sb.from('reviews').select('*')
      .order('sort_order', { ascending: true })
      .order('created_at', { ascending: false });
    if (featured) q = q.eq('is_featured', true);
    if (limit) q = q.limit(limit);

    var res = await q;
    var rows = (res.data || []);
    if (res.error || !rows.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (moreWrap) moreWrap.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;

    grid.innerHTML = rows.map(cardHtml).join('');
    var cards = Array.prototype.slice.call(grid.children);

    if (page && cards.length > page) {
      var shown = page;
      cards.forEach(function (c, i) { c.hidden = i >= shown; });
      if (moreWrap) {
        moreWrap.hidden = false;
        moreWrap.querySelector('button').addEventListener('click', function () {
          shown += page;
          cards.forEach(function (c, i) { if (i < shown) c.hidden = false; });
          if (shown >= cards.length) moreWrap.hidden = true;
        });
      }
    } else if (moreWrap) {
      moreWrap.hidden = true;
    }

    wireTilt(grid);
    wireLightbox(grid);
  }

  document.querySelectorAll('[data-rv-root]').forEach(mount);
})();
